import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
    getFrasersPaymentsApi,
    getFrasersPaymentByIdApi,
    refreshFrasersPaymentApi,
    sendFrasersReminderApi,
} from "../../../services/frasersPlus";

export const getFrasersPayments = createAsyncThunk("frasersPlus/getPayments", async (params, { dispatch }) => {
    const response = await getFrasersPaymentsApi(params);
    dispatch(setFrasersPayments(response.response));
    return response.response;
});

export const getFrasersPaymentById = createAsyncThunk("frasersPlus/getPaymentById", async (id) => {
    const response = await getFrasersPaymentByIdApi(id);
    return response.response;
});

export const refreshFrasersPayment = createAsyncThunk("frasersPlus/refreshPayment", async (id, { dispatch }) => {
    const response = await refreshFrasersPaymentApi(id);
    toast.info(response.response.message);
    dispatch(setFrasersPaymentDetails(response.response.payment));
    return response.response;
});

export const sendFrasersReminderForPayment = createAsyncThunk("frasersPlus/sendReminder", async (orderId, { dispatch }) => {
    const response = await sendFrasersReminderApi(orderId);
    if (response.response.ok) {
        toast.success(response.response.message);
    } else {
        toast.error(response.response.message);
    }
    dispatch(setFrasersPaymentReminders(response.response.reminders));
    return response.response;
});

const frasersPlusSlice = createSlice({
    name: "frasersPlus",
    initialState: {
        list: [],
        tableRows: 0,
        counts: { paid: 0, awaiting: 0, not_paid: 0, credit_failed: 0, not_started: 0 },
        details: null,
    },
    reducers: {
        setFrasersPayments: (state, action) => {
            state.list = action.payload.data || [];
            state.tableRows = action.payload.count || 0;
            state.counts = action.payload.counts || state.counts;
        },
        setFrasersPaymentDetails: (state, action) => {
            state.details = action.payload || null;
        },
        clearFrasersPaymentDetails: (state) => {
            state.details = null;
        },
        setFrasersPaymentReminders: (state, action) => {
            if (state.details) state.details.reminders = action.payload || [];
        },
    },
    extraReducers: {
        [getFrasersPaymentById.fulfilled]: (state, action) => {
            state.details = action.payload;
        },
    },
});

export const { setFrasersPayments, setFrasersPaymentDetails, clearFrasersPaymentDetails, setFrasersPaymentReminders } = frasersPlusSlice.actions;

export default frasersPlusSlice.reducer;
